import React, { useState } from 'react';
import FirstRow from '@/pages/intelligence/components/TableComponents/components/FirstRow';
import TextActivities from '@/pages/intelligence/components/CardComponents/BlockbusterGamesCard/TextActivities';
import TextBubbles from '@/pages/home/components/TextBubbles';
import GameImage from '@/pages/home/components/GameImage';
import './index.scss';

export default function BlockbusterGamesCard(props: any) {
  const { data, onClick, onDescClick } = props;
  const { list, linkUrl } = data || {};
  return (
    <div className="dbi-blockbuster-card">
      <div className="blockbuster-card-img">
        {/* <img src={data?.img} alt="" /> */}
        <GameImage src={data?.img} entityType={'background'} />
      </div>

      <div className="blockbuster-card-cont">
        <FirstRow
          cvm={{
            ...list,
            text: <span>{list?.text}</span>,
            imgType: list?.entity_type || list?.imgType,
          }}
          rihgtClickToJumpHref={linkUrl}
          onClick={() => {
            onClick('', data);
          }}
        />
        <div className="blockbuster-card-info" onClick={onDescClick}>
          <img className="blockbuster-card-icon" src={data?.icon} alt="" />
          <div className="blockbuster-card-desc">{data?.desc}</div>
        </div>

        <TextBubbles className="blockbuster-card-title" text={data?.title} />

        {data?.text ? (
          <TextActivities text={data?.text} title={data?.title} />
        ) : (
          <div className="dbi-market-textactivities-text">-</div>
        )}
      </div>
    </div>
  );
}
